module.exports = __webpack_public_path__ + "img/map2_seoul_dang.8c9f922a.jpg";